import {
    TableCell,
    TableRow,
} from "@mui/material";
import {tableCellClasses} from "@mui/material/TableCell";
import {styled} from "@mui/material/styles";
import {NavLink} from "react-router";
import MdiIcon from "../../../share/components/mdi/MdiIcon.tsx";

export const StyledTableCell = styled(TableCell)(({theme}) => ({
    [`&.${tableCellClasses.head}`]: {
        fontWeight: 'bold'
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

export const SmallTableHeaderRow = styled(TableRow)(({theme}) => ({
    '&.MuiTableRow-root': {
    },
}));

export const SmallTableRow = styled(TableRow)(({theme}) => ({
    '&.MuiTableRow-root': {
        cursor: "pointer",
    },
}));

export const BigTableHeaderRow = styled(TableRow)(({theme}) => ({
    '&.MuiTableRow-root': {
    },
}));

export const BigTableRow = styled(TableRow)(({theme}) => ({
    '&.MuiTableRow-root': {
        cursor: "pointer",
    },
}));

export const ToolbarTableCell = styled(TableCell)(({theme}) => ({
    '&.MuiTableCell-root': {
        cursor: "pointer",
    },
}));

export const StyledNavLink = styled(NavLink)(({theme}) => ({
    textDecoration: 'none',
    '&:hover': {
        textDecoration: 'underline',
    },
    '&:hover button span': {
        textDecoration: 'none',
    },
}));

export const StyledFillNavLink = styled(NavLink)(({theme}) => ({
    textDecoration: 'none',
    display: 'block',
    width: '100%',
    height: '100%',
    '&:hover': {
        textDecoration: 'none',
    },
    '&:hover button span': {
        textDecoration: 'none',
    },
    '&.MuiLink-root': {
        textDecoration: 'none',
    },
}));

export const StyledMdiIcon = styled(MdiIcon)(({theme}) => ({
    fontSize: 'small',
}));